export const getSegmentKey = (host: string): string => {
    try {
        if (host?.includes('localhost')) {
            return 'OmV7jAWTCgzH5jCxRpM1UBbAJfGUsOOj';
        }
        if (
            process.env.NEXT_PUBLIC_ENVIRONMENT === 'sandbox2' ||
            process.env.NEXT_PUBLIC_ENVIRONMENT === 'master' ||
            process.env.NEXT_PUBLIC_ENVIRONMENT === 'isnp'
        ) {
            return 'OmV7jAWTCgzH5jCxRpM1UBbAJfGUsOOj';
        }
        return 'Db7qg80zZq79SffgRblhPHcSuBwraILN';
    } catch {
        return 'OmV7jAWTCgzH5jCxRpM1UBbAJfGUsOOj';
    }
};
